module.exports = __webpack_public_path__ + "fonts/brelaregular.296984a.woff2";